import { useCart } from '../../context/CartContext';

function AddToCartButton({ project }) {
  const { addToCart, removeFromCart, isInCart, hasPurchased, currentUser } = useCart();

  // Not logged in — show disabled prompt
  if (!currentUser) {
    return <span className="add-to-cart-btn add-to-cart-btn--purchased">Sign in to buy</span>;
  }

  // Owner doesn't need to buy their own project
  if (currentUser.uid === project.ownerId) {
    return <span className="add-to-cart-btn add-to-cart-btn--purchased">Your Project</span>;
  }

  // Already purchased
  if (hasPurchased(project.projectId)) {
    return <span className="add-to-cart-btn add-to-cart-btn--purchased">Purchased ✓</span>;
  }

  const inCart = isInCart(project.projectId);

  const handleClick = async (e) => {
    e.stopPropagation();
    if (inCart) {
      await removeFromCart(project.projectId);
    } else {
      await addToCart(project);
    }
  };

  return (
    <button
      className={`add-to-cart-btn ${inCart ? 'add-to-cart-btn--in-cart' : ''}`}
      onClick={handleClick}
    >
      {inCart ? 'Remove from Cart' : 'Add to Cart'}
    </button>
  );
}

export default AddToCartButton;
